<template>
	<div
		class="tag js-zoom-bar-tag"
		:class="{ [`-${type}`]: type, 'is-edited': isEdited }"
		:style="tagStyle"
	/>
</template>

<script>
const DOT_SIZE = 6;

export default {
	props: {
		time: {
			type:     Number,
			required: true,
		},
		type: {
			type:     String,
			required: true,
		},
		isEdited: {
			type:    Boolean,
			default: false,
		},
		duration: {
			type:    Number,
			default: 0,
		},
	},
	computed: {
		tagStyle() {
			return { left: `min(${(this.time * 100) / this.duration}%, calc(100% - ${DOT_SIZE}px))` };
		},
	},
};
</script>

<style lang="scss" scoped>
@import './timeline.scss';

.tag {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	width: 6px;
	height: 6px;
	border-radius: 100%;

	&.-participant {
		background: $timeline-slider-tag;
	}

	&.-event {
		background: $timeline-slider-tag-neutral;
	}

	&.-neutral {
		background: $timeline-slider-tag-neutral;
	}

	&.is-edited {
		background: $timeline-slider-tag-edited;
	}
}
</style>
